// workaround for CSVLink not working with async loaded data :(
// https://github.com/react-csv/react-csv/issues/350

import React, { useEffect, useRef, useState } from "react";
import Button from "./Button";

// @ts-ignore
import { CSVLink } from "react-csv";

interface CSVDownloadProps extends React.HTMLAttributes<HTMLDivElement> {
  data: any[]; // <-- now an array, not a function returning a Promise
  filename: string;
  headers: Array<{ label: string; key: string }>;
  /** auto trigger download when data changes and has rows */
  autoDownload?: boolean;
  /** called right after the download is triggered */
  onDownloaded?: () => void;
}

const CSVDownload2: React.FC<CSVDownloadProps> = ({
                                                    data,
                                                    filename,
                                                    headers,
                                                    autoDownload = true,
                                                    onDownloaded,
                                                    ...rest
                                                  }) => {
  // CSVLink's ref type: it holds { link: HTMLAnchorElement }
  const linkRef = useRef<CSVLink & { link: HTMLAnchorElement }>(null as any);

  useEffect(() => {
    if (!autoDownload) return;
    if (Array.isArray(data) && data.length > 0 && linkRef.current?.link) {
      // Trigger download
      linkRef.current.link.click();
      onDownloaded?.();
    }
  }, [data, autoDownload, onDownloaded]);

  // Render-only CSVLink. Parent controls when `data` becomes non-empty.
  return (
    <div {...rest} style={{ display: "inline" }}>
      <CSVLink
        ref={linkRef as any}
        data={data || []}
        filename={filename}
        headers={headers}
        target="_blank"
      />
    </div>
  );
};
export default CSVDownload2;
